import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanLoad, UrlSegment, Route } from '@angular/router';

import { AuthService } from '../../auth/auth-service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private authService: AuthService, private router: Router, private translate: TranslateService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.checkIfLoggedIn()) {
      return true;
    } else {
      let url = '/' + (window.location.href.includes('/en') ? 'en' : 'ar') + '/auth'
      this.router.navigate([url]);
    }

    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkLoginOnly();
  }

  checkLogin(role: string, permissions?: string[]): boolean {
    if (this.authService.checkIfLoggedIn() && this.authService.checkIfAuthorized(role, permissions)) {
      return true;
    } else {
      let url = '/' + (window.location.href.includes('/en') ? 'en' : 'ar') + '/auth'
      this.router.navigate([url]);
    }

    return false;
  }

  checkLoginOnly(): boolean {
    if (this.authService.checkIfLoggedIn()) {
      return true;
    } else {
      let url = '/' + (window.location.href.includes('/en') ? 'en' : 'ar') + '/auth'
      this.router.navigate([url]);
    }

    return false;
  }
}
